import { createFileRoute } from '@tanstack/react-router'

import { AuthPage } from '@/pages/auth/authPage'

export const Route = createFileRoute('/auth')({
	component: AuthPage,
	validateSearch: (search: Record<string, unknown>): { next?: string } => {
		return {
			next: search.next as string | undefined,
		}
	},
})
